import { msg } from '@lingui/core/macro';
import { StageType } from 'modules/championship/domain/enums/stage-type';
import type { MessageDescriptor } from 'shared/i18n';

/** Подписи типов этапа (в GraphQL и прежних i18n-ключах — `roundType`). */
export const STAGE_TYPE_LABELS: Record<StageType, MessageDescriptor> = {
  [StageType.ROUND_ROBIN_1]: msg`Один круг`,
  [StageType.ROUND_ROBIN_2]: msg`Два круга`,
  [StageType.SINGLE_ELIMINATION]: msg`Выбывание`,
  [StageType.DOUBLE_ELIMINATION]: msg`Выбывание после двух поражений`,
  [StageType.GROUP]: msg`Групповой`,
};

export function getStageTypeLabel(type?: string | null): MessageDescriptor | undefined {
  return type && type in STAGE_TYPE_LABELS ? STAGE_TYPE_LABELS[type as StageType] : undefined;
}
